import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const aviApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Emergent Google OAuth entry
export function googleLoginRedirect() {
  const redirect = encodeURIComponent(`${window.location.origin}/app`);
  window.location.href = `https://auth.emergentagent.com/?redirect=${redirect}`;
}

// SSE streaming for Avi chat (cookie-authenticated)
export async function aviStream(payload, { onMeta, onChips, onToken, onError, onDone }) {
  const res = await fetch(`${BACKEND_URL}/api/me/chat/stream`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok || !res.body) {
    let detail = "Something went wrong";
    try { detail = (await res.json()).detail || detail; } catch (e) {}
    onError?.(detail);
    onDone?.();
    return;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data:")) continue;
      try {
        const ev = JSON.parse(line.slice(5));
        if (ev.type === "meta") onMeta?.(ev);
        else if (ev.type === "chips") onChips?.(ev.chips || []);
        else if (ev.type === "token") onToken?.(ev.content);
        else if (ev.type === "error") onError?.(ev.content);
        else if (ev.type === "done") onDone?.(ev);
      } catch (e) {}
    }
  }
  onDone?.();
}
